<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2 class="mb-0">Registro</h2>
      <!-- <router-link to="/evidencias" class="btn btn-colgate px-4"
        >Ver evidencias</router-link
      > -->
    </div>
    <RegistroForm />
  </div>
</template>

<script setup>
import RegistroForm from "../components/RegistroForm.vue";
</script>

<style scoped>
.btn-colgate {
  background: #e4002b;
  color: #fff;
  border: none;
  font-weight: 700;
  padding: 0.6rem 1.2rem;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(228, 0, 43, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.btn-colgate:hover {
  background: #c70024;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(228, 0, 43, 0.35);
}
</style>
